import React from "react";
import * as c from '../../../../../../constants.jsx';
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from "../../../../../../components/Alert/ActionAlert.jsx";
import CardMarkerSmall from '../../../../../../components/CockpitCards/CardMarkerSmall.jsx';
import VariantCardAccordion from "../../../../../../components/TextComps/VariantCardAccordion.jsx";
import ButtonGeneRed from "../../../../../../components/Button/ButtonGeneRed.jsx";


export default function MendelianCard() {

const url_variantpheno = `${c.API_URL}/api/masterpatho` 

const [variantInfo, setVariantInfo] = React.useState(null);
const [error, setError] = React.useState(null);
    
    React.useEffect(() => {
      retrieveVariantPheno();
    }, []);
    
    const retrieveVariantPheno = () => {
      axios
        .get(url_variantpheno)
        .then((res) => {
          setVariantInfo(res.data);
    
        })
        .catch(function (error) {
          if (error.response) {
            // Request made and server responded
            setError(error.response.data);
          } else if (error.request) {
            // The request was made but no response was received
            setError("The request was made but no response was received.");
          } else {
            // Something happened in setting up the request that triggered an Error
            setError("Error: " + error.message);
          }
        });
    };

return(
<>

{variantInfo ? (

<CardMarkerSmall

  headline = "MENDELIAN DISORDER" 
  subtext = {"Mendelian disorders are caused by changes in a single gene with well-known effects. Variants linked to these conditions are classified as pathogenic or likely pathogenic based on ACMG guidelines. This means there is strong evidence that the variant can cause or increase the risk of a specific genetic condition."}

  cardlines = {<>

    {variantInfo.map((i) => (
        
        <VariantCardAccordion key={i.id} 
        
                   marker = {<ButtonGeneRed name={i.SYMBOL} /> }
                    gene = {i.SYMBOL}
                    gene_name={i.GeneName}
                    MANE_SELECT={i.MANE_SELECT}
                    location={i.Uploaded_variation}
                    group={i.BIOTYPE}
                    variation={"Variant"}
                    var_g={i.HGVSg}
                    consequence={i.Consequence}
                    var_p={i.HGVSp}
                    gt={"-"} 
                    type={i.VARIANT_CLASS}
                    exon={i.EXON}
                    rs={i.RS}
                    expert={i.CLNREVSTAT}
                    classification={i.CLNSIG}
                    clinvarID={i.clinvarID}
                    pheno={"Phenotype"}
                    pheno_name={i.CLNDN}
         />  
))}   
</>  }
/>

) : (

    <Grid container mt={2} mb={2} justifyContent="center" rowspacing={2}>
        <Grid size={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

)
}

{error && (
          <Grid container mt={2} mb={1} justifyContent="center" rowspacing={1}>
            <Grid size={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

